import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { unix } from 'moment';
import { TaskCommentsComponent } from '../../../partials/content/general/task-comments/task-comments.component';
import { WorkflowModReviewComponent } from '../workflow-mod-review/workflow-mod-review.component';

@Component({
  selector: 'kt-workflow-history',
  templateUrl: './workflow-history.component.html',
  styleUrls: ['./workflow-history.component.scss'],
})
export class WorkflowHistoryComponent {
  @Input() loadingHistory;
  @Input() history;
  @Input() wqHistory;
  @Input() wqCommentsHistory;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
    if (data) {
      this.loadingHistory = false;
      this.history = data.history;
      this.wqHistory = data.wqHistory;
      this.wqCommentsHistory = data.wqCommentsHistory;
    }
  }

  getFormattedDate(timestamp) {
    return unix(timestamp / 1000).format('YYYY-MM-DD hh:mm a');
  }

  getHistoryText(record) {
    switch (record.isComment) {
      case true:
        return record.comment;
      case false:
        return record.name;
      default:
        return '';
    }
  }

  openDialog(event, record) {
    event.stopPropagation();

    let length;
    let idx;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;

    if (!record.isComment) {
      length = this.wqHistory.length;
      idx = this.wqHistory.indexOf(record);

      const isUpdateWQ = record.rev_type === 'MOD' && length > 1 && idx < length - 1;

      dialogConfig.width = isUpdateWQ ? '90vw' : '45vw';
      dialogConfig.data = isUpdateWQ
        ? [this.wqHistory[idx], this.wqHistory[idx + 1]]
        : [this.wqHistory[idx]];

      this.dialog.open(WorkflowModReviewComponent, dialogConfig);

      return;
    }

    length = this.wqCommentsHistory.length;
    idx = this.wqCommentsHistory.indexOf(record);

    const isUpdateWQComment = record.rev_type === 'MOD' && length > 1 && idx < length - 1;

    dialogConfig.width = '400px';
    dialogConfig.data = isUpdateWQComment
      ? [this.wqCommentsHistory[idx], this.wqCommentsHistory[idx + 1]]
      : [this.wqCommentsHistory[idx]];

    this.dialog.open(TaskCommentsComponent, dialogConfig);
  }
}
